import React from 'react';
import { Hero } from './Hero';
import { WhyChooseUs } from './WhyChooseUs';
import { HowItWorks } from './HowItWorks';
import { BrandsAndVehicles } from './BrandsAndVehicles';
// import { Newsletter } from './Newsletter';
import { Faq } from './Faq';
import { SEO } from './SEO';

export const Home: React.FC = () => {
  return (
    <>
      <SEO
        title="Sell Car Easy - Professional Car Valuation Service"
        description="Get the best price for your car with our professional valuation service. Fast, reliable, and stress-free car valuation and selling process."
        path="/"
      />
      <section id="hero">
        <Hero />
      </section>
      <section id="services">
        <WhyChooseUs />
      </section>
      <section id="how-it-works">
        <HowItWorks />
      </section>
      <section id="brands">
        <BrandsAndVehicles />
      </section>
      <section id="faq">
        <Faq />
      </section>
    </>
  );
}; 